import { h, Component } from 'preact'
import { connect } from 'react-redux'

import Input from '../../../shared/components/Input.jsx'
import Button from '../../../shared/components/Button.jsx'

import { submitGiftAddress } from '../state/actions/gift.js'

import '../style/components/CompleteStep.less'

class CompleteStep extends Component {

	constructor(props) {
		super(props)

		const { firstName, lastName } = props

		this.state = {
			firstName: firstName || '',
			firstNameValid: !!firstName,
			lastName: lastName || '',
			lastNameValid: !!lastName,
			company: '',
			companyValid: true, // Optional field
			address1: '',
			address1Valid: false,
			city: '',
			cityValid: false,
			usState: '',
			usStateValid: false,
			zip: '',
			zipValid: false,
			country: 'United States',
			countryValid: true,
			showGiftForm: false
		}
	}

	handleInputFirstName = e => {
		this.setState({
			firstName: e.target.value,
			firstNameValid: e.target.checkValidity()
		})
	}

	handleInputLastName = e => {
		this.setState({
			lastName: e.target.value,
			lastNameValid: e.target.checkValidity()
		})
	}

	handleInputCompany = e => {
		this.setState({
			company: e.target.value,
			companyValid: e.target.checkValidity()
		})
	}

	handleInputAddress1 = e => {
		this.setState({
			address1: e.target.value,
			address1Valid: e.target.checkValidity()
		})
	}

	handleInputCity = e => {
		this.setState({
			city: e.target.value,
			cityValid: e.target.checkValidity()
		})
	}

	handleInputState = e => {
		this.setState({
			usState: e.target.value,
			usStateValid: e.target.checkValidity()
		})
	}

	handleInputZip = e => {
		this.setState({
			zip: e.target.value,
			zipValid: e.target.checkValidity()
		})
	}

	handleChangeCountry = e => {
		this.setState({
			country: e.target.value,
			countryValid: true
		})
	}

	handleClaimGift = e => {
		e.preventDefault()
		this.setState({ showGiftForm: true })
	}

	handleSubmit = e => {
		e.preventDefault()

		const { firstName, lastName, company, address1, city, usState, zip, country } = this.state
		const { preauthToken, email } = this.props

		// Send "no company" if company field is empty
		const companyValue = company.trim() || 'no company'

		// Redux action will set gift.submitted to true on success
		this.props.submitGiftAddress(preauthToken, email, firstName, lastName, companyValue, address1, city, usState, zip, country)
	}

	render(props, state) {
		const { email, giftSubmitted, giftSubmitting, giftError } = props
		const {
			firstName, firstNameValid,
			lastName, lastNameValid,
			company, companyValid,
			address1, address1Valid,
			city, cityValid,
			usState, usStateValid,
			zip, zipValid,
			country, countryValid,
			showGiftForm
		} = state

		const formValid = firstNameValid && lastNameValid && companyValid && address1Valid && cityValid && usStateValid && zipValid && countryValid

		// Show gift confirmation after submission
		if (giftSubmitted) {
			return (
				<section class="CompleteStep">
					<div class="gift-confirmation">
						<div class="gift-icon">✓</div>
						<h3>Your gift request has been submitted!</h3>
						<div class="important-notice">
							<strong>Important:</strong> Keep watching your email for credentials and instructions for the demo.
						</div>
					</div>
				</section>
			)
		}

		// Show gift form if user clicked "Claim Your Free Gift!"
		if (showGiftForm) {
			return (
				<section class="CompleteStep">
					<h2>Claim Your Free Gift!</h2>
					<p>As a thank you for trying our demo, we'd like to send you a gift. Please provide your mailing address:</p>

					{giftError && (
						<div class="gift-error">
							<p>{giftError}</p>
						</div>
					)}

					<form spellcheck="false" onsubmit={ this.handleSubmit }>
						<div class="field-group">
							<label for="gift-firstName">First Name</label>
							<Input
								id="gift-firstName"
								type="text"
								errors={{
									valueMissing: 'Please enter your first name'
								}}
								value={ firstName }
								placeholder="John"
								oninput={ this.handleInputFirstName }
								onchange={ this.handleInputFirstName }
								required
							/>
						</div>

						<div class="field-group">
							<label for="gift-lastName">Last Name</label>
							<Input
								id="gift-lastName"
								type="text"
								errors={{
									valueMissing: 'Please enter your last name'
								}}
								value={ lastName }
								placeholder="Doe"
								oninput={ this.handleInputLastName }
								onchange={ this.handleInputLastName }
								required
							/>
						</div>

						<div class="field-group">
							<label for="company">Company (Optional)</label>
							<Input
								id="company"
								type="text"
								errors={{}}
								value={ company }
								placeholder="Acme Corporation"
								oninput={ this.handleInputCompany }
								onchange={ this.handleInputCompany }
							/>
						</div>

						<div class="field-group">
							<label for="address1">Street Address</label>
							<Input
								id="address1"
								type="text"
								errors={{
									valueMissing: 'Please enter your street address'
								}}
								value={ address1 }
								placeholder="123 Main Street"
								oninput={ this.handleInputAddress1 }
								onchange={ this.handleInputAddress1 }
								required
							/>
						</div>

						<div class="field-group">
							<label for="city">City</label>
							<Input
								id="city"
								type="text"
								errors={{
									valueMissing: 'Please enter your city'
								}}
								value={ city }
								placeholder="New York"
								oninput={ this.handleInputCity }
								onchange={ this.handleInputCity }
								required
							/>
						</div>

						<div class="field-group">
							<label for="state">State</label>
							<Input
								id="state"
								type="text"
								errors={{
									valueMissing: 'Please enter your state'
								}}
								value={ usState }
								placeholder="NY"
								oninput={ this.handleInputState }
								onchange={ this.handleInputState }
								required
							/>
						</div>

						<div class="field-group">
							<label for="zip">Zip Code</label>
							<Input
								id="zip"
								type="text"
								errors={{
									valueMissing: 'Please enter your zip code',
									patternMismatch: 'Please enter a valid zip code'
								}}
								value={ zip }
								placeholder="10001"
								pattern="[\d\-]{5,10}"
								oninput={ this.handleInputZip }
								onchange={ this.handleInputZip }
								required
							/>
						</div>

						<div class="field-group">
							<label for="country">Country</label>
							<select
								id="country"
								value={ country }
								onchange={ this.handleChangeCountry }
								required
							>
								<option value="United States">United States</option>
								<option value="Canada">Canada</option>
							</select>
						</div>

						<Button type="submit" disabled={ !formValid || giftSubmitting }>
							{giftSubmitting ? 'Submitting...' : 'Submit Address'}
						</Button>
					</form>
				</section>
			)
		}

		// Default view: Account Created with option to claim gift
		return (
			<section class="CompleteStep">
				<div class="success-icon">✓</div>
				<h2>Account Created!</h2>
				<p>Your demo account has been successfully created.</p>
				<p class="email-info">
					Login credentials have been sent to:<br/>
					<strong>{ email }</strong>
				</p>
				<p class="next-steps">
					Check your email for login instructions and get started with your demo.
				</p>

				<hr />

				<div class="gift-offer">
					<div class="gift-icon">🎁</div>
					<h3>Claim Your Free Gift!</h3>
					<p>As a thank you for trying our demo, we'd like to send you a gift.</p>
					<Button className="submit" onClick={ this.handleClaimGift }>
						Claim Your Free Gift!
					</Button>
				</div>
			</section>
		)
	}
}

const mapStateToProps = state => ({
	email: state.email.address,
	firstName: state.email.firstName,
	lastName: state.email.lastName,
	preauthToken: state.email.preauthToken,
	giftSubmitted: state.gift.submitted,
	giftSubmitting: state.gift.submitting,
	giftError: state.gift.error
})

const mapDispatchToProps = dispatch => ({
	submitGiftAddress: (preauthToken, email, firstName, lastName, company, address1, city, state, zip, country) =>
		dispatch(submitGiftAddress(preauthToken, email, firstName, lastName, company, address1, city, state, zip, country))
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CompleteStep)
